<template>
<el-dialog class='media-audio-dialog' :title="$t('title')" :visible.sync="dialogVisible" @close='close'>
  <el-tabs v-model="currentTag" header-no-margin @tab-click='fetchData'>
    <el-tab-pane class="audio-content" :label="$t(`tags.${tag}`)" :name="tag" v-for="tag in tags" :key="tag">
      <div class='audio-item uploading' v-if='onUploading'>
        <div class='name'>
          <i class='ppj-icon-spinner'></i> {{uploadingFilename}}
        </div>
        <div class='progress' :style="{'width': progress * 0.8 + '%'}">
        </div>
      </div>

      <el-table :data="audios[tag]" style="width: 100%" :show-header="false" highlight-current-row v-on:current-change="selected = $event ? $event.id : null" ref='table'>
        <el-table-column>
          <template scope="scope">
            <div class='audio-item'>
              <i :class="currentPlayIndex === scope.$index ? 'ppj-icon-play' : 'ppj-icon-music'" ></i>
              <div class='name'>
                  {{scope.row.name}}
                  <span class='duration'>
                    {{durationReadable(scope.row.duration)}}
                  </span>
              </div>
              <a class='btn trash' v-show='tag !== "pub" && scope.row.id !== selected' v-on:click.stop="remove(scope.$index)">
                <i class='ppj-icon-trash'></i>
              </a>
              <a class='btn' v-on:click.stop="play(scope.$index)" v-show="currentPlayIndex !== scope.$index">
                <i class='ppj-icon-play'></i>
                </a>
              <a class='btn' v-on:click.stop="pause()" v-show="currentPlayIndex === scope.$index">
                <i class='ppj-icon-pause'></i>
              </a>
              <i class='ppj-icon-ok' v-show='scope.row.id === selected'></i>
            </div>
          </template>
        </el-table-column>
        <div slot="empty">
          <span class="empty-hint" v-show='!onUploading'>{{$t('empty')}}</span>
        </div>
      </el-table>
    </el-tab-pane>
  </el-tabs>

  <div slot="footer" class="dialog-footer">
    <ssuploader class='uploader-btn' :url="uploadUrl" :data="uploadData" name='medium[file]' :extensions="extensions" :filename.sync="uploadingFilename" :progress.sync="progress" :uploading.sync="onUploading" :accept="accept" @complete="uploadComplete" />
    <el-button type='text' @click="close">{{$t('common.buttons.cancel')}}</el-button>
    <el-button type='primary' @click="save">{{$t('common.buttons.ok')}}</el-button>
  </div>
</el-dialog>
</template>

<i18n>
{
  "zh-cn": {
    "title": "从素材库选取音乐",
    "empty": "暂时没有音乐",
    "tags": {
      "bgm": "背景音乐",
      "pub": "公共音乐"
    },
    "messagebox": {
      "remove": {
        "title": "从素材库中移除该音乐?",
        "message": "注意，该操作不会使之前引用的文件失效"
      },
      "close": {
        "title": "请保持素材库打开",
        "message": "上传文件中，请勿关闭素材库"
      },
      "save": {
        "title": "请选择音乐后保存",
        "message": "单击某条音乐来选中，或点击取消按钮来关闭素材库"
      }
    }
  }
}
</i18n>

<script>
import SSUploader from '@/components/widgets/ss_uploader.input'
import lodash from 'lodash'

export default {
  data() {
    return {
      // data stored related
      audios: {}, // audios: {'tag': [list]}
      currentTag: 'bgm',
      tags: ['bgm', 'pub'],
      selected: null,
      success: null,
      // ui update related
      dialogVisible: false,
      onUploading: false,
      uploadingFilename: null,
      progress: 0, // uploading percentage
      // player related
      player: null,
      paused: false,
      currentPlayIndex: null,
      currentAt: null,
      // uploader parameters
      extensions: ['mp3', 'wav', 'm4a', 'acc', 'ogg', 'wma'],
      accept: '.mp3, .wav, .m4a, .acc, .ogg, .wma, audio/*',
      // page related
      currentPage: 1,
      totalPages: 1,
      totalItems: 1,
      pageSize: 1
    }
  },
  components: {
    'ssuploader': SSUploader
  },
  computed: {
    uploadUrl() {
      let organization = this.$store.getters['user/organization']
      return organization ? `${process.env.API_ROOT}organizations/${organization.id}/media` : `${process.env.API_ROOT}media`
    },
    uploadData() {
      return { 'medium[type]': 'audio', 'medium[tag]': this.currentTag }
    }
  },
  watch: {
    onUploading: function(newValue) {
      if (newValue) {
        this.currentTag = 'bgm'
      }
    }
  },
  methods: {
    open(params) {
      this.fetchData()
      this.success = params.success
      this.dialogVisible = true
    },
    fetchData() {
      let vm = this
      vm.$store.dispatch('media/index', {
        type: 'audio',
        tag: 'bgm',
        public: vm.currentTag === 'pub',
        page: vm.currentPage
      }).then(res => {
        let data = res.data
        vm.$set(vm.audios, vm.currentTag, data.list || [])
        vm.pageSize = data.page_size
        vm.totalItems = data.total_items
        vm.totalPages = data.total_pages
      })
    },
    // player related methods
    update(e) {
      this.currentAt = this.durationReadable(this.player.currentTime)
    },
    play(index) {
      let vm = this
      let fileUrl = vm.audios[vm.currentTag][index].file_url
      if (!fileUrl) {
        vm.$message({
          message: '目标文件音频地址有问题，请刷新或联系客服',
          type: 'error'
        })
        return
      }

      if (!vm.player) {
        vm.player = new Audio()
      }

      vm.currentPlayIndex = index
      if (vm.player.src !== fileUrl) {
        vm.player.src = fileUrl
      }
      vm.player.addEventListener('timeupdate', vm.update)
      vm.paused = false
      vm.player.play()
    },
    pause() {
      let vm = this
      if (vm.player) {
        vm.currentPlayIndex = null
        vm.paused = true
        vm.player.removeEventListener('timeupdate', vm.update)
        vm.player.pause()
      }
    },
    remove(index) {
      let vm = this
      let target = vm.audios[vm.currentTag][index]
      vm.$confirm(vm.$t('messagebox.remove.message'), vm.$t('messagebox.remove.title'), {
        cancelButtonClass: 'el-button--text',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: vm.$t('common.buttons.cancel'),
        confirmButtonText: vm.$t('common.buttons.ok')
      }).then(_ => {
        if (vm.currentPlayIndex === index) {
          vm.pause()
        }
        vm.$store.dispatch('media/destroy', target.id).then(_ => {
          vm.audios[vm.currentTag].splice(index, 1)
        })
      }).catch(_ => {})
    },
    save() {
      let vm = this
      if (!vm.selected) {
        // 未选中音乐
        vm.$alert(vm.$t('messagebox.save.message'), vm.$t('messagebox.save.title'), {
          confirmButtonText: vm.$t('common.buttons.ok')
        }).then(_ => {}).catch(_ => {})
      } else {
        let list = vm.audios[vm.currentTag]

        if (vm.success) {
          vm.success(JSON.parse(JSON.stringify(list[lodash.findIndex(list, { id: vm.selected })])))
        }
        vm.close()
      }
    },
    close() {
      let vm = this

      if (vm.onUploading) {
        // 文件上传中
        vm.$alert(vm.$t('messagebox.close.message'), vm.$t('messagebox.close.title'), {
          confirmButtonText: vm.$t('common.buttons.ok')
        }).then(_ => {}).catch(_ => {})
      } else {
        vm.pause()
        vm.selected = null
        vm.dialogVisible = false
      }
    },
    uploadComplete(data) {
      let vm = this
      vm.$refs['table'][0].setCurrentRow()
      vm.audios[vm.currentTag].splice(0, 0, data)
      vm.$nextTick(function() {
        vm.selected = data.id

        if (vm.currentPlayIndex !== null) {
          vm.currentPlayIndex = vm.currentPlayIndex + 1
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.media-audio-dialog {
    .el-table tr {
        &:hover {
            cursor: pointer;

            .btn {
                display: inline-block;
            }

            .ppj-icon-ok {
                display: none;
            }
        }
    }
    .audio-content {
        height: 20em;
        overflow-y: auto;
    }
    .empty-hint {
        white-space: nowrap;
    }

    .uploading {
        height: 40px;
        padding-left: 4px;
        position: relative;
        .name {
            line-height: 40px;
            z-index: 2;
            position: relative;
        }
        .progress {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 0;
            z-index: 1;
            background-color: lighten($color-info, 15%);
        }
    }

    .audio-item {
        [class^='ppj-icon'] {
            margin-left: 0.5em;
            margin-right: 0.5em;
            float: left;
        }

        .name {
            float: left;
            width: 80%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            .duration {
                margin-left: 1em;
                color: $color-gray-base;
            }
        }

        .btn {
            float: right;
            display: none;
            &:hover {
                color: $font-color-strong;
            }
        }

        .ppj-icon-ok {
            float: right;
        }
    }

    .dialog-footer {
        .uploader-btn {
            float: left;
        }
    }
}
</style>



// WEBPACK FOOTER //
// audio.dialog.vue?df12776e